"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorForValue = exports.getColorForCalendarDataCard = void 0;
const colors = __importStar(require("../assets/styles/colors"));
const hexToRGB_1 = __importDefault(require("./hexToRGB"));
const COLORS_FOR_RANGES = (thresholdValues) => [
    {
        max: thresholdValues.min - 1,
        color: colors.grey,
        borderColor: colors.grey,
    },
    {
        max: thresholdValues.low,
        color: colors.green100,
        borderColor: colors.green200,
    },
    {
        max: thresholdValues.middle,
        color: colors.yellow100,
        borderColor: colors.yellow200,
    },
    {
        max: thresholdValues.high,
        color: colors.orange100,
        borderColor: colors.orange200,
    },
    {
        max: thresholdValues.max,
        color: colors.red100,
        borderColor: colors.red200,
    },
    { max: Infinity, color: colors.grey, borderColor: colors.gray300 }, // grey color for values out of scale
];
const getColorForValue = (thresholdValues, value, isBorder) => {
    const defaultColor = "transparent";
    if (value !== 0 && !value)
        return defaultColor;
    for (let range of COLORS_FOR_RANGES(thresholdValues)) {
        if (Number(value) <= Number(range.max)) {
            return isBorder ? range.borderColor : range.color;
        }
    }
    return defaultColor;
};
exports.getColorForValue = getColorForValue;
const getColorForCalendarDataCard = (color) => {
    switch (color) {
        case colors.green100:
            return `linear-gradient(241deg, ${(0, hexToRGB_1.default)(colors.blue, 0.4)} -32.4%, ${(0, hexToRGB_1.default)(colors.blue, 0.05)} 94.94%), ${colors.green100}`;
        case colors.red100:
            return `linear-gradient(241deg, ${(0, hexToRGB_1.default)(colors.royalPurple, 0.4)} -38.43%, ${(0, hexToRGB_1.default)(colors.royalPurple, 0)} 94.94%), ${colors.red100}`;
        case colors.orange100:
            return `linear-gradient(241deg, ${(0, hexToRGB_1.default)(colors.lightCrimson, 0.4)} -2.4%, ${(0, hexToRGB_1.default)(colors.lightCrimson, 0)} 94.94%), ${colors.orange100}`;
        case colors.yellow100:
            return `linear-gradient(241deg, ${(0, hexToRGB_1.default)(colors.rose, 0.2)} -43.4%, ${(0, hexToRGB_1.default)(colors.white, 0)} 34.94%), ${colors.yellow100}`;
        default:
            return `linear-gradient(241deg, ${(0, hexToRGB_1.default)(colors.gray100, 0.4)} -2.4%, ${(0, hexToRGB_1.default)(colors.gray100, 0)} 94.94%), ${colors.gray300}`;
    }
};
exports.getColorForCalendarDataCard = getColorForCalendarDataCard;
